export default __webpack_public_path__ + "static/media/up_PC.a461475c.svg";